import { DEFAULT_LIST_SIZE as f } from "../../constants/layout.js";
const o = (s) => {
  const {
    page: i = 1,
    pageSize: r = f,
    previousCursor: e = null,
    nextCursor: t = null
  } = s;
  return e ? {
    before: e,
    first: r
  } : t ? {
    after: t,
    first: r
  } : {
    offset: (i - 1) * r,
    first: r
  };
};
export {
  o as serializePagingInput
};
//# sourceMappingURL=index.js.map
